/** The longest delay `setTimeout` keeps; anything longer wraps around (WebIDL `long`) and fires at a random time */
export const MAX_TIMEOUT_MS = 2 ** 31 - 1
/** An active session moves to a fresh token at least this often (S03: a rotated signing secret reaches everyone in use) */
export const REFRESH_AFTER_MS = 24 * 60 * 60 * 1000
const MIN_DELAY_MS = 5000

/**
 * How long to wait before refreshing the token, or null when it has no expiry. Refresh 5 s before it expires, and once
 * it is a day old, whichever comes first; never sooner than 5 s, never past what `setTimeout` can hold.
 *
 * Password logins get 365-day tokens: "expiry − 5 s" alone wrapped to about 17 days, so whether a load refreshed at all
 * depended on the token's age (flexime_tools W77, 2026-11-04).
 */
export function tokenRefreshDelay(token: { exp?: number; iat?: number }, now: number): number | null {
  if (!token?.exp) return null
  const untilExpiry = token.exp * 1000 - now - MIN_DELAY_MS
  const untilDayOld = token.iat ? token.iat * 1000 + REFRESH_AFTER_MS - now : Infinity
  return Math.min(Math.max(Math.min(untilExpiry, untilDayOld), MIN_DELAY_MS), MAX_TIMEOUT_MS)
}
